// extracted by mini-css-extract-plugin
export default {"container":"VerifyEmail_container__FT3MS","spinner":"VerifyEmail_spinner__OE5A-","shake-horizontal":"VerifyEmail_shake-horizontal__k4VUV","grow":"VerifyEmail_grow__uJsu1"};